export default __webpack_public_path__ + "static/media/header.dad3b6fd.jpg";